import type { PropsWithChildren } from 'react';
import { cn } from '../../lib/utils.ts';

type Props = {
    className?: string;
} & PropsWithChildren;

export function DataText({ children, className = '' }: Props) {
    return <span className={cn('tabular-nums', className)}>{children}</span>;
}
